import { atomWithStorage } from "jotai/utils";

interface OpenedTestEntry {
  openedAt: number; // timestamp when test was opened
}

type OpenedTestsState = Record<string, OpenedTestEntry>;

const TWO_WEEKS_MS = 14 * 24 * 60 * 60 * 1000;

// Prune entries older than 2 weeks
const pruneOldEntries = (state: OpenedTestsState): OpenedTestsState => {
  const now = Date.now();
  const pruned: OpenedTestsState = {};
  for (const [id, entry] of Object.entries(state)) {
    if (now - entry.openedAt < TWO_WEEKS_MS) {
      pruned[id] = entry;
    }
  }
  return pruned;
};

export const openedTestsAtom = atomWithStorage<OpenedTestsState>(
  "openedTests",
  {},
  {
    getItem: (key, initialValue) => {
      const stored = localStorage.getItem(key);
      if (!stored) {
        return initialValue;
      }
      try {
        return pruneOldEntries(JSON.parse(stored));
      } catch {
        return initialValue;
      }
    },
    setItem: (key, value) => {
      localStorage.setItem(key, JSON.stringify(pruneOldEntries(value)));
    },
    removeItem: (key) => localStorage.removeItem(key),
  }
);

export const isTestNew = (
  testId: string,
  createdAt: string | Date,
  openedTests: OpenedTestsState
): boolean => {
  const createdTime = new Date(createdAt).getTime();
  const now = Date.now();

  // Only show indicator if created in last 2 weeks
  if (now - createdTime > TWO_WEEKS_MS) {
    return false;
  }

  // Check if test has been opened
  return !openedTests[testId];
};
